import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  ListMenu: {
    background: 'var(--Gray-600, #475467)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexShrink: '0',
    alignSelf: 'stretch',
    height: '100%',
    padding: '32px 0 24px !important',
    gap: '16px',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none',
    },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
  },
  BoxMenu: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '24px',
    alignSelf: 'stretch',
  },
  BoxStyles: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    paddingRight: '16px',
    alignSelf: 'stretch',
  },
  Logo: {
    width: '48px',
    height: '48px',
    borderRadius: '4px',
  },
  TextItem: {
    color: 'var(--Gray-100, #F2F4F7)',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '24px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    letterSpacing: '0.15px',
    flex: 1,
  },
  Collapse: {
    width: '100%',
  },
  MenuButton: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
    gap: '12px',
    width: '100%',
    textDecoration: 'none',
    justifyContent: 'flex-start',
    textTransform: 'none',
    color: 'var(--Base-White, #FFF)',
    borderRadius: '8px',
    textAlign: 'left',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  MenuButtonSub: {
    paddingLeft: '48px',
    padding: '8px 12px',
  },
  MenuButtonActive: {
    backgroundColor: 'var(--Gray-700, #344054)',
  },
  MenuButtonLogout: {
    '& .MuiListItemText-root': {
      color: 'var(--Error-500, #F04438) !important',
    },
  },
  BoxImage: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flexDirection: 'column',
  },
  FixedStyles: {
    position: 'fixed',
  },
}));

export { useStyles };

